'use client';

import { useEffect, useState } from 'react';
import Figure from './figure';
import { configLightboxSize } from '@/app/lib/utils/helpers';

interface Props {
  src: string;
  alt: string;
  lightboxPortalId: string;
  isStatement?: boolean;
}

export default function FigureContainer({ src, alt, lightboxPortalId }: Props) {
  const { width, height, aspect, lightboxWidths, lightboxHeights } =
    configLightboxSize(src);

  const [lightboxPortal, setLightboxPortal] = useState<
    HTMLElement | null | undefined
  >(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setLightboxPortal(document.getElementById(lightboxPortalId));
  }, [lightboxPortalId]);

  return (
    <Figure
      src={src}
      alt={alt}
      width={width}
      height={height}
      aspect={aspect}
      lightboxWidths={lightboxWidths}
      lightboxHeights={lightboxHeights}
      open={open}
      setOpen={setOpen}
      lightboxPortal={lightboxPortal}
    />
  );
}
